import { Component } from '@angular/core';

@Component({
  selector: 'app-topbar-chat',
  imports: [],
  templateUrl: './topbar-chat.component.html',
  styleUrl: './topbar-chat.component.scss'
})
export class TopbarChatComponent {

}
